import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { bootstrapTenantFromUrl } from './core/tenant.interceptor';

@Component({
    standalone: true,
    imports: [RouterOutlet],
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    ngOnInit(): void {
        bootstrapTenantFromUrl();
    }
}
